/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "fac",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "int24",
                name: "pt",
                type: "int24",
            },
            {
                internalType: "uint128",
                name: "amountX",
                type: "uint128",
            },
        ],
        name: "addLimOrderWithX",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "int24",
                name: "pt",
                type: "int24",
            },
            {
                internalType: "uint128",
                name: "amountY",
                type: "uint128",
            },
        ],
        name: "addLimOrderWithY",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "factory",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "pool",
                type: "address",
            },
            {
                internalType: "address",
                name: "miner",
                type: "address",
            },
            {
                internalType: "int24",
                name: "pt",
                type: "int24",
            },
            {
                internalType: "bool",
                name: "sellXEarnY",
                type: "bool",
            },
        ],
        name: "getEarn",
        outputs: [
            {
                internalType: "uint256",
                name: "lastAccEarn",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "sellingRemain",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "sellingDesc",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "earn",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "legacyEarn",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "earnAssign",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "pool",
                type: "address",
            },
            {
                internalType: "address",
                name: "miner",
                type: "address",
            },
            {
                internalType: "int24",
                name: "pt",
                type: "int24",
            },
        ],
        name: "getEarnX",
        outputs: [
            {
                internalType: "uint256",
                name: "lastAccEarn",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "sellingRemain",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "sellingDesc",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "earn",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "legacyEarn",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "earnAssign",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "pool",
                type: "address",
            },
            {
                internalType: "address",
                name: "miner",
                type: "address",
            },
            {
                internalType: "int24",
                name: "pt",
                type: "int24",
            },
        ],
        name: "getEarnY",
        outputs: [
            {
                internalType: "uint256",
                name: "lastAccEarn",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "sellingRemain",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "sellingDesc",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "earn",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "legacyEarn",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "earnAssign",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "x",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "y",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "payCallback",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
        ],
        name: "pool",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class TestAddLimOrder__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(fac, overrides) {
        return super.deploy(fac, overrides || {});
    }
    getDeployTransaction(fac, overrides) {
        return super.getDeployTransaction(fac, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
TestAddLimOrder__factory.bytecode = _bytecode;
TestAddLimOrder__factory.abi = _abi;
